import React, { useState } from "react";
import { BUTTON_STYLE, INPUT_LABEL_STYLE, INPUT_STYLE } from "../../assets/constants";
import { BsFillEyeFill, BsFillEyeSlashFill } from "react-icons/bs";
import { useRef } from "react";
import { useEffect } from "react";
import { useLayoutEffect } from "react";


export default function Form({ title, data }) {
    const [studentId, setStudentId] = useState(null);
    const [userName, setUserName] = useState(null);
    const [name, setName] = useState(null);
    const [email, setEmail] = useState(null);
    const [password, setPassword] = useState(null);
    const [birthDate, setBirthDate] = useState(null);
    const [address, setAddress] = useState(null);
    const [contact, setContact] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [disable, setDisable] = useState(false);
    const [errorMessage, setErrorMessage] = useState({
        nameError: null,
        userNameError: null,
        emailError: null,
        studentIdError:null,
        contactError: null,
        addressError: null,
        passwordError: null,
        birthDateError: null,
        idError: null,
    });

    const loadOnce = useRef(true)
    useEffect(() => {

        if (loadOnce.current) {
            console.log(data);

            loadOnce.current = false;
            setDisable(data?true:false);
            setStudentId(data?.studentId);
            setUserName(data?.userName);
            setName(data?.name);
            setPassword(data?.password);
            // setBirthDate(data?.birthDate);
            setEmail(data?.email);
            setContact(data?.contact);
            setAddress(data?.address);
        }
    }, [data]);

    const handleSubmit = async () => {

        const body = {
            studentId: studentId,
            name: name,
            userName: userName,
            contact: contact,
            password: password,
            email: email,
            address: address,
            birthDate: birthDate,

        };
        console.log(body);
    };

    function validateFileds() {
        let error = false
        if (!name) {
            setErrorMessage((prevState) => ({
                ...prevState,
                nameError: 'Please enter student Name',
            }));
            error = true;
        } else if (name?.legth < 5) {
            setErrorMessage((prevState) => ({
                ...prevState,
                nameError: 'Student Name must be at least 5 characters long',
            }));
            error = true;
        }
        if (!userName) {
            setErrorMessage((prevState) => ({
                ...prevState,
                userNameError: 'Please enter student userName',
            }));
            error = true;
        } else if (userName?.legth < 6) {
            setErrorMessage((prevState) => ({
                ...prevState,
                userNameError: 'Username must be at least 6 characters long',
            }));
            error = true;
        }
        if (!email) {
            setErrorMessage((prevState) => ({
                ...prevState,
                emailError: 'Please enter email',
            }));
            error = true;
        }
        if (!password) {
            setErrorMessage((prevState) => ({
                ...prevState,
                passwordError: "Please enter password",
            }));
            error = true;
        } else if (password?.legth < 8) {
            setErrorMessage((prevState) => ({
                ...prevState,
                passwordError: "Password must be at least 8 characters long",
            }));
            error = true;
        }
        if (!contact) {
            setErrorMessage((prevState) => ({
                ...prevState,
                contactError: 'Please enter contact Number',
            }));
            error = true;
        }
        if (!address) {
            setErrorMessage((prevState) => ({
                ...prevState,
                contactError: 'Please enter student address',
            }));
            error = true;
        }
        return error
    }
    return (
        <div className="">
            <div className="bg-white shadow-lg hover:shadow-blue-100 rounded-lg w-full md:w-11/12 xl:w-3/4 mx-auto">
                <div className="py-10 px-5 space-y-10 select-none">
                    <h1 className="text-4xl font-bold text-center">{title}</h1>
                    {/* name and username */}
                    <div className="grid sm:grid-cols-2 space-y-10 sm:space-y-0 sm:gap-5">
                        {/* name */}
                        <div className="">
                            <div className="relative">
                                <input
                                    type="text"
                                    id="floating_outlined"
                                    className={`${INPUT_STYLE} ${errorMessage.nameError && "border-red-600 text-red-600"}`}
                                    placeholder=" "
                                    value={name}
                                    disabled={disable}
                                    onChange={(e) => setName(e.target.value)}
                                    onBlur={() => {
                                        !name && setErrorMessage(prev => ({
                                            ...prev,
                                            nameError: "Name is required"
                                        }))
                                    }}
                                    onClick={() => {
                                        errorMessage.nameError && setErrorMessage(prev => ({
                                            ...prev,
                                            nameError: null
                                        }))
                                    }}

                                />
                                <label
                                    htmlFor="floating_outlined"
                                    className={`${INPUT_LABEL_STYLE} ${errorMessage.nameError && "text-red-600"}`}

                                >
                                    Name
                                </label>
                            </div>
                            <p className="text-sm text-red-600 h-4">{errorMessage.nameError}</p>
                        </div>

                        {/* username */}
                        <div>
                            <div className="relative">
                                <input
                                    type="text"
                                    name="userName"
                                    id="floating_userName"
                                    placeholder=" "
                                    value={userName}
                                    disabled={disable}
                                    className={`${INPUT_STYLE} ${errorMessage.userNameError && "border-red-600 text-red-600"}`}
                                    onChange={(e) => setUserName(e.target.value)}
                                    onBlur={() => {
                                        !userName && setErrorMessage(prev => ({
                                            ...prev,
                                            userNameError: "User Name is required"
                                        }))
                                    }}
                                    onClick={() => {
                                        errorMessage.userNameError && setErrorMessage(prev => ({
                                            ...prev,
                                            userNameError: null
                                        }))
                                    }}
                                />
                                <label
                                    htmlFor="floating_userName"
                                    className={`${INPUT_LABEL_STYLE} ${errorMessage.userNameError && "text-red-600"}`}
                                >
                                    User Name
                                </label>
                            </div>
                            <p className="text-sm text-red-600 h-4">{errorMessage.userNameError}</p>

                        </div>
                    </div>

                    {/* email and password */}
                    <div className="grid sm:grid-cols-2 space-y-10 sm:space-y-0 sm:gap-5">
                        {/* email */}
                        <div>
                            <div className="relative">
                                <input
                                    type="email"
                                    id="floating_email"
                                    value={email}
                                    placeholder=" "
                                    disabled={disable}
                                    className={`${INPUT_STYLE} ${errorMessage.emailError && "border-red-600 text-red-600"}`}
                                    onChange={(e) => setEmail(e.target.value)}
                                    onBlur={() => {
                                        !email && setErrorMessage(prev => ({
                                            ...prev,
                                            emailError: "Email is required"
                                        }))
                                    }}
                                    onClick={() => {
                                        errorMessage.emailError && setErrorMessage(prev => ({
                                            ...prev,
                                            userNameError: null
                                        }))
                                    }}
                                />
                                <label
                                    htmlFor="floating_userName"
                                    className={`${INPUT_LABEL_STYLE} ${errorMessage.emailError && "text-red-600"}`}
                                >
                                    Email
                                </label>
                            </div>
                            <p className="text-sm text-red-600 h-4">{errorMessage.emailError}</p>

                        </div>

                        {/* password */}
                        <div>

                            <div className="relative">
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    id="floating_password"
                                    placeholder=" "
                                    disabled={disable}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)} className={`${INPUT_STYLE} ${errorMessage.passwordError && "border-red-600 text-red-600"}`}
                                    onBlur={() => {
                                        !password && setErrorMessage(prev => ({
                                            ...prev,
                                            passwordError: "Password is required"
                                        }))
                                    }}
                                    onClick={() => {
                                        errorMessage.passwordError && setErrorMessage(prev => ({
                                            ...prev,
                                            passwordError: null
                                        }))
                                    }}
                                />
                                <label
                                    htmlFor="floating_password"
                                    className={`${INPUT_LABEL_STYLE} ${errorMessage.passwordError && "text-red-600"}`}

                                >
                                    Password
                                </label>
                                {showPassword ? <BsFillEyeSlashFill onClick={() => setShowPassword(false)} className={`absolute top-5 cursor-pointer right-4 w-6 h-5 ${errorMessage.passwordError && "text-red-600"} `} />
                                    : <BsFillEyeFill onClick={() => setShowPassword(true)} className={`absolute top-5 right-4 w-6 h-5 cursor-pointer ${errorMessage.passwordError && "text-red-600"}`} />
                                }
                            </div>
                            <p className="text-sm text-red-600 h-4">{errorMessage.passwordError}</p>

                        </div>
                    </div>

                    {/* phone and address */}

                    <div className="grid sm:grid-cols-2 space-y-10 sm:space-y-0 sm:gap-5">
                        {/* contact */}
                        <div>
                            <div className="relative">
                                <input
                                    type="text"
                                    id="floating_contact"
                                    placeholder=" "
                                    value={contact}
                                    disabled={disable}
                                    className={`${INPUT_STYLE} ${errorMessage.contactError && "border-red-600 text-red-600"}`}
                                    onChange={(e) => setContact(e.target.value)}
                                    onBlur={() => {
                                        !contact && setErrorMessage(prev => ({
                                            ...prev,
                                            contactError: "Contact is required"
                                        }))
                                    }}
                                    onClick={() => {
                                        errorMessage.contactError && setErrorMessage(prev => ({
                                            ...prev,
                                            contactError: null
                                        }))
                                    }}
                                />
                                <label
                                    htmlFor="floating_contact"
                                    className={`${INPUT_LABEL_STYLE} ${errorMessage.contactError && "text-red-600"}`}
                                >
                                    Contact
                                </label>
                            </div>
                            <p className="text-sm text-red-600 h-4">{errorMessage.contactError}</p>

                        </div>
                        {/* address */}
                        <div>
                            <div className="relative">
                                <input
                                    type="text"
                                    id="floating_address"
                                    placeholder=" "
                                    value={address}
                                    disabled={disable}
                                    className={`${INPUT_STYLE} ${errorMessage.addressError && "border-red-600 text-red-600"}`}
                                    onChange={(e) => setAddress(e.target.value)}
                                    onBlur={() => {
                                        !address && setErrorMessage(prev => ({
                                            ...prev,
                                            addressError: "Contact is required"
                                        }))
                                    }}
                                    onClick={() => {
                                        errorMessage.addressError && setErrorMessage(prev => ({
                                            ...prev,
                                            addressError: null
                                        }))
                                    }}
                                />
                                <label
                                    htmlFor="floating_address"
                                    className={`${INPUT_LABEL_STYLE} ${errorMessage.addressError && "text-red-600"}`}
                                >
                                    Address
                                </label>
                            </div>
                            <p className="text-sm text-red-600 h-4">{errorMessage.addressError}</p>

                        </div>
                    </div>

                    

                    <div className="grid sm:grid-cols-2 space-y-10 sm:space-y-0 sm:gap-5">
                        {/* contact */}
                        <div>
                            <div className="relative">
                                <input
                                    type="text"
                                    id="floating_student_id"
                                    placeholder=" "
                                    value={studentId}
                                    disabled={disable}
                                    className={`${INPUT_STYLE} ${errorMessage.studentIdError && "border-red-600 text-red-600"}`}
                                    onChange={(e) => setStudentId(e.target.value)}
                                    onBlur={() => {
                                        !studentId && setErrorMessage(prev => ({
                                            ...prev,
                                            studentIdError: "Student id is required"
                                        }))
                                    }}
                                    onClick={() => {
                                        errorMessage.studentIdError && setErrorMessage(prev => ({
                                            ...prev,
                                            studentIdError: null
                                        }))
                                    }}
                                />
                                <label
                                    htmlFor="floating_student_id"
                                    className={`${INPUT_LABEL_STYLE} ${errorMessage.studentIdError && "text-red-600"}`}
                                >
                                    Contact
                                </label>
                            </div>
                            <p className="text-sm text-red-600 h-4">{errorMessage.contactError}</p>

                        </div>
                        {/* address */}
                        <div>
                            {/* date of bith */}
                            <div className="relative">
                                <input
                                    type="date"
                                    id="floating_birthDate"
                                    className={INPUT_STYLE}
                                    placeholder=" "
                                    value={birthDate}
                                    disabled={disable}
                                    onChange={(e) => setBirthDate(e.target.value)}
                                />
                                <label
                                    htmlFor="floating_birthDate"
                                    className={INPUT_LABEL_STYLE}
                                >
                                    Date of Birth
                                </label>
                            </div>
                            {/* <p className="text-sm text-red-600 h-4">{errorMessage.addressError}</p> */}

                        </div>
                    </div>

                    <div className="flex justify-between items-center">
                        {!disable && <button className={`${BUTTON_STYLE} px-5 font-medium`} onClick={handleSubmit}>
                            Submit
                        </button>}
                        {disable && <button className={`${BUTTON_STYLE} px-5 font-medium`} onClick={()=> setDisable(false)}>
                            Edit
                        </button>}
                    </div>
                </div>
            </div>
        </div>
    );
}

